import "./UserFeed.css";
import avatar from "../assets/images/use-app.png";
import amazone from "../assets/images/amazone.jpg";
import loginImg from "../assets/images/logo.svg";

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Icons
import { BiAddToQueue } from "react-icons/bi";
import { MdOutlineNotifications } from "react-icons/md";
import { IoSettingsOutline } from "react-icons/io5";
import { AiOutlineSend } from "react-icons/ai";
import { FaEllipsisV, FaEdit, FaTrash } from "react-icons/fa";
import {
  FaSearch,
  FaHome,
  FaUserFriends,
  FaUserCircle,
  FaLink,
  FaMicrophone,
  FaMapMarkerAlt,
} from "react-icons/fa";

const UserFeed = () => {
  const navigate = useNavigate();

  const [showSettings, setShowSettings] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [postText, setPostText] = useState("");

  /* ===============================
     ✅ POSTS WITH LOCAL STORAGE
  =============================== */
  const [posts, setPosts] = useState(() => {
    const savedPosts = localStorage.getItem("user_posts");
    return savedPosts
      ? JSON.parse(savedPosts)
      : [
          {
            id: 1,
            user: "Andrew Wade",
            time: "1m",
            content:
              "This morning is fun. Playing golf and we make some challenge. Not winning today, but not bad 😄",
            date: "December 27, 2025",
          },
        ];
  });

  // 🔥 SAVE POSTS ON EVERY CHANGE
  useEffect(() => {
    localStorage.setItem("user_posts", JSON.stringify(posts));
  }, [posts]);

  /* ===============================
     EDIT / DELETE STATES
  =============================== */
  const [openMenuId, setOpenMenuId] = useState(null);
  const [editPostId, setEditPostId] = useState(null);
  const [editText, setEditText] = useState("");

  const handleLogout = () => {
    localStorage.removeItem("user_posts");
    navigate("/login");
  };

  const handlePostSubmit = () => {
    if (!postText.trim()) return;

    const newPost = {
      id: Date.now(),
      user: "Jhon Thomar",
      time: "Just now",
      content: postText,
      date: new Date().toDateString(),
    };

    setPosts([newPost, ...posts]);
    setPostText("");
  };

  const handleDelete = (id) => {
    setPosts(posts.filter((post) => post.id !== id));
    setOpenMenuId(null);
  };

  const handleEdit = (post) => {
    setEditPostId(post.id);
    setEditText(post.content);
    setOpenMenuId(null);
  };

  const handleUpdatePost = (id) => {
    setPosts(
      posts.map((post) =>
        post.id === id ? { ...post, content: editText } : post
      )
    );
    setEditPostId(null);
    setEditText("");
  };

  return (
    <div className="feed">

      {/* ===== Top Header ===== */}
      <div className="top-header">
        <span className="brand">
          <img src={loginImg} alt="Logo" className="login-image" />
        </span>

        <div className="top-actions">
          <button
            className="icon-btn"
            onClick={() => {
              setShowNotifications(!showNotifications);
              setShowSettings(false);
            }}
          >
            <MdOutlineNotifications />
          </button>

          <button
            className="icon-btn"
            onClick={() => {
              setShowSettings(!showSettings);
              setShowNotifications(false);
            }}
          >
            <IoSettingsOutline />
          </button>
        </div>

        {showNotifications && (
          <div className="dropdown notification-dropdown">
            <p className="dropdown-title">Notifications</p>
            <ul>
              <li>🔔 New follower joined</li>
              <li>❤️ Someone liked your post</li>
              <li>💬 New comment on your post</li>
            </ul>
          </div>
        )}

        {showSettings && (
          <div className="dropdown settings-dropdown">
            <button onClick={handleLogout}>Logout</button>
          </div>
        )}
      </div>

      {/* ===== Create Post ===== */}
      <div className="profile-card">
        <div className="post-box">
          <div className="post-header">
            <img src={avatar} alt="User" className="avatar" />

            <div className="post-input-area">
              <h4>Jhon <span>Thomar</span></h4>
              <input
                type="text"
                placeholder="What’s on your mind?"
                value={postText}
                onChange={(e) => setPostText(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handlePostSubmit()}
              />
            </div>
          </div>

          <div className="post-input-actions">
            <FaLink />
            <FaMicrophone />
            <FaMapMarkerAlt />
          </div>

          <div className="postsend" onClick={handlePostSubmit}>
            <AiOutlineSend />
          </div>
        </div>
      </div>

      {/* ===== POSTS ===== */}
      {posts.map((post) => (
        <div className="post-card" key={post.id}>
          <div className="post-head">
            <img src={avatar} alt="user" />
            <div>
              <h4>{post.user}</h4>
              <span>{post.time}</span>
            </div>

            <div className="post-menu">
              <FaEllipsisV
                onClick={() =>
                  setOpenMenuId(openMenuId === post.id ? null : post.id)
                }
              />

              {openMenuId === post.id && (
                <div className="menu-dropdown">
                  <button onClick={() => handleEdit(post)}>
                    <FaEdit /> Edit
                  </button>
                  <button onClick={() => handleDelete(post.id)}>
                    <FaTrash /> Delete
                  </button>
                </div>
              )}
            </div>
          </div>

          {editPostId === post.id ? (
            <div className="edit-box">
              <textarea
                value={editText}
                onChange={(e) => setEditText(e.target.value)}
              />
              <div className="edit-actions">
                <button onClick={() => handleUpdatePost(post.id)}>Save</button>
                <button onClick={() => setEditPostId(null)}>Cancel</button>
              </div>
            </div>
          ) : (
            <p className="post-text">{post.content}</p>
          )}

          <div className="post-meta">
            <span>{post.date}</span>
          </div>

          <div className="post-footer-actions">
            <span>❤️ Like</span>
            <span>💬 Comment</span>
            <span>↗ Share</span>
          </div>
        </div>
      ))}
{/* ===== Job Card (Amazon / LinkedIn Style) ===== */} <div className="post-card job-card"> <div className="post-head"> <img src={amazone} alt="user" /> <div> <h4>Andrew Wade</h4> {/* <span>Recent Post .3mins</span> */} </div> </div> <div className="job-header"> <span className="company">Amazone</span> <span className="time">2 days ago</span> </div> <h3 className="job-title">Amazon Posts: Strategies, Benefits, and Free Advertising Tips</h3> <p class="post-text">Capturing customer attention in a sea of millions of products on Amazon can be challenging. One effective way to enhance visibility and foster engagement is by using Amazon Posts. This feature lets brands build their own community and attract shopping interest. In this article, we’ll explore Amazon Posts and share tips to enhance your brand content on Amazon.</p> {/* <div className="job-tags"> <span>Full time</span> <span>Senior level</span> </div> */} <div className="job-footer"> <div className="job-left"> <span className="viewed">Viewed</span> <span className="location">📍 Nairobi – Kenya</span> </div> <button className="details-btn">See Details</button> </div> <div className="post-footer-actions"> <span>❤️ Like</span> <span>💬 Comment</span> <span>↗ Share</span> </div> </div>
      {/* ===== Bottom Navigation ===== */}
      <div className="bottom-footer">
        <button className="footer-item active">
          <FaHome />
          <span>Home</span>
        </button>

        <button className="footer-item">
          <FaSearch />
          <span>Search</span>
        </button>

        <button
          className="footer-item create-post"
          onClick={() => navigate("/createpost")}
        >
          <BiAddToQueue />
        </button>

        <button className="footer-item">
          <FaUserFriends />
          <span>Network</span>
        </button>

        <button className="footer-item" onClick={() => navigate("/profile")}>
          <FaUserCircle />
          <span>Profile</span>
        </button>
      </div>
    </div>
  );
};

export default UserFeed;
